export default "__VITE_ASSET__CxcVopZl__"